import { useEffect } from 'react';
import { createFileRoute, Outlet, redirect, useNavigate } from '@tanstack/react-router';
import { useBinScopedStore } from '@amber-ui/core/src/stores/bin-scoped-store';
import { useAuth } from '@amber-ui/core/src/contexts/auth-context';

// Module-level variables track previous pile/acct for Zustand state reset in beforeLoad.
let previousPile: string | undefined;
let previousAcct: string | undefined;

export const Route = createFileRoute('/_auth/_pile')({
  validateSearch: (search: Record<string, unknown>): { pile?: string; acct?: string } => ({
    pile:
      typeof search.pile === 'string' && /^[a-zA-Z0-9]{8,}$/.test(search.pile)
        ? search.pile
        : undefined,
    acct:
      typeof search.acct === 'string' && /^[a-zA-Z0-9]{8,}$/.test(search.acct)
        ? search.acct
        : undefined,
  }),
  beforeLoad: ({ search, context: { auth } }) => {
    const currentPile = search.pile;
    const currentAcct = search.acct;

    if (previousAcct !== undefined && currentAcct !== previousAcct) {
      useBinScopedStore.getState().resetAll();
    } else if (previousPile !== undefined && currentPile !== previousPile) {
      useBinScopedStore.getState().resetBinState();
    }

    previousPile = currentPile;
    previousAcct = currentAcct;

    if (currentPile && !currentAcct && auth?.account_id) {
      throw redirect({
        to: '.',
        search: { ...search, acct: auth.account_id },
        replace: true,
      });
    }
  },
  component: function PileLayout() {
    const { pile, acct } = Route.useSearch();
    const { account_id: sessionAccountId } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (pile && !acct && sessionAccountId) {
        void navigate({
          // oxlint-disable-next-line typescript/no-explicit-any -- TanStack Router's navigate generic overloads make precise typing impractical for search merge
          search: { pile, acct: sessionAccountId } as any,
          replace: true,
        });
      }
    }, [pile, acct, sessionAccountId, navigate]);

    return <Outlet />;
  },
});
